import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import Error from "types/error";
import { SharesMonthly } from "types/share";

export default function useSharesMonthlyCount(search?: Record<string, string>) {
  const request: Request = {
    url: ENDPOINTS.shares.monthlyCount,
    config: {
      method: "GET",
      params: { ...search },
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.shares.monthlyCount, search && JSON.stringify(search)],
    queryFn: () => client(request).then((res) => res.data),
  };

  const { data, ...rest } = useQuery<SharesMonthly[], Error>(requestConfig);

  return { data, ...rest };
}
